export default () => {
  return [
    {
      title: '账号管理',
      icon: 'el-icon-user',
      children: [
        {
          title: '用户信息',
          router: { name: 'UserInfo' },
        },
      ],
    },
  ]
}
